// import { createAction } from '@reduxjs/toolkit';
import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const paychexOnboardingSignupDataModuleActions = createDataModuleActions(
    'PAYCHEX_ONBOARDING_SIGNUP',
);

export const paychexOnboardingSignup =
    paychexOnboardingSignupDataModuleActions.dataRequest;
export const paychexOnboardingSignupSuccess =
    paychexOnboardingSignupDataModuleActions.dataSuccess;
export const paychexOnboardingSignupError =
    paychexOnboardingSignupDataModuleActions.dataError;
export const paychexOnboardingSignupReset =
    paychexOnboardingSignupDataModuleActions.dataReset;

// TODO: uncomment when verify phone will be integrated
// export const completeSignupRequirements = createAction(
//     'backend/STORE::COMPLETE_SIGNUP_REQUIREMENTS',
// );
